module.exports = __webpack_public_path__ + "static/media/377.ebc5a712.svg";